import React from "react";
import visibleEyeIcon from "../assets/svg/visibleEyeIcon.svg";
import nonVisibleEyeIcon from "../assets/svg/nonVisibleEyeIcon.svg";

interface Props {
  hide: boolean;
}

const defaultProps = {
  hide: true,
};

const PasswordVisibility: React.FC<Props> = (props): React.ReactElement<any> => {
  const { hide = defaultProps.hide } = props;
  const imgSrc = hide ? nonVisibleEyeIcon : visibleEyeIcon;
  return (
    <img src={imgSrc} alt="password-visibility-toggle"/>
  );
};

export default PasswordVisibility;
